import { createSlice } from '@reduxjs/toolkit';
import { get } from '../../services/apiController';

const initialState = {
  totalRecords: 0,
  subCategories: [],
};

const CakeSubCategorySlice = createSlice({
  name: 'CakeSubCategorySlice',
  initialState,
  reducers: {
    setCategories(state, action) {
      state.subCategories = action?.payload;
    },
    setTotalRecords(state, action) {
      state.totalRecords = action?.payload;
    },
  },
});

export const FetchSubCategories = (query) => async (dispatch) => {
  try {
    let url = '/cake/categories/?type=child';
    if (query) {
      url += query;
    }
    get(url)
      .then((res) => {
        dispatch(setCategories(res?.data?.rows));
        dispatch(setTotalRecords(res?.data?.count));
      })
      .catch((err) => {
        console.log('error', err);
      });
  } catch (e) {
    console.log('error', e);
  }
};

export const { setCategories, setTotalRecords } = CakeSubCategorySlice.actions;
export default CakeSubCategorySlice.reducer;
